<footer class="footer footer-style">
        <mat-icon>facebook</mat-icon>
        <mat-icon class="icon" svgIcon="instagram"></mat-icon>
    <div class="footer-copyright text-center py-3">© 2020 Copyright:
        <a href="/home"> Mechweb.com</a>
    </div>
</footer>